const VERSION: string = '0.1.7-prod.110'
export default VERSION;
